import type { CreationForm } from './creationForm';
import { CreationSelect } from './CreationSelect';
import {
  CreationBoardMode,
  CreationBoardSelection,
} from './CreationBoardFields';

function ProjectField({ repository, feedback }: CreationForm) {
  return (
    <CreationSelect
      id="create-project"
      label="Projeto Azure DevOps"
      query={repository.options.projects}
      value={repository.value.project}
      optionValue={p => p.name}
      optionKey={p => p.name}
      optionLabel={p => p.name}
      onChange={value => {
        repository.selectProject(value);
        feedback.clearFields('project');
      }}
      feedbackLabel="projetos"
      loadingText="Carregando projetos..."
      error={feedback.fieldErrors.project}
    />
  );
}
function RepositoryField({ repository, feedback }: CreationForm) {
  return (
    <CreationSelect
      id="create-repo"
      label="Repositório"
      query={repository.options.repositories}
      value={repository.value.repository}
      optionValue={r => r.name}
      optionKey={r => r.id}
      optionLabel={r => r.name}
      onChange={value => {
        repository.selectRepository(value);
        feedback.clearFields('repo');
      }}
      disabled={!repository.value.project}
      feedbackLabel="repositórios"
      loadingText="Carregando repositórios..."
      error={feedback.fieldErrors.repo}
    />
  );
}
function BranchField({
  form: { repository, feedback },
  label,
}: {
  form: CreationForm;
  label: string;
}) {
  return (
    <CreationSelect
      id="create-branch"
      label={label}
      query={repository.options.branches}
      value={repository.value.branch}
      optionValue={b => b.name}
      optionKey={b => b.name}
      optionLabel={b => `${b.name}${b.isDefault ? ' (padrão)' : ''}`}
      onChange={value => {
        repository.selectBranch(value);
        feedback.clearFields('branch');
      }}
      disabled={!repository.value.repository}
      feedbackLabel="branches"
      loadingText="Carregando branches..."
      error={feedback.fieldErrors.branch}
      branch
    />
  );
}
export function CreationRepositoryFields({
  form,
  branchLabel,
}: {
  form: CreationForm;
  branchLabel: string;
}) {
  if (!form.providers.isAzure) return null;
  return (
    <>
      <ProjectField {...form} />
      <CreationBoardMode {...form} />
      <CreationBoardSelection {...form} />
      <RepositoryField {...form} />
      <BranchField form={form} label={branchLabel} />
    </>
  );
}
